module.exports = __webpack_public_path__ + "img/hippo.5f3c31ab.jpg";